import { Box } from "@material-ui/core";
import { Link } from "react-router-dom";

import { useStyles } from "../checkoutSuccessPage.styles";
import { useBreakpoint } from "../../../hooks/useBreakpoint";

export const Header = () => {
  const classes = useStyles();
  const { isMoreThanSm } = useBreakpoint();

  return (
    <Box
      py={isMoreThanSm ? "33px" : "32px"}
      px={isMoreThanSm ? "0" : "16px"}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"space-between"}
      bgcolor={"transparent"}
    >
      <Link to="/">
        <img className={classes.logo} src={process.env.PUBLIC_URL + "/images/logo-swyft-white.svg"} alt="Logo" />
      </Link>
    </Box>
  );
};
